import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useSettings } from "@/contexts/SettingsContext";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/weddings", label: "Weddings" },
  { to: "/reels", label: "Reels" },
  { to: "/moodboards", label: "Moodboards" },
  { to: "/stories", label: "Stories" },
  { to: "/about", label: "About" },
];

export default function Header() {
  const { settings } = useSettings();
  const [open, setOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const loc = useLocation();

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  React.useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled ? "backdrop-blur-md bg-[color:var(--bg)]/70 border-b border-[color:var(--border)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1500px] mx-auto flex items-center justify-between px-5 md:px-10 h-16 md:h-20">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-3 group">
          {settings.logo_url ? (
            <img src={settings.logo_url} alt={settings.brand_name} className="h-8 md:h-10 w-auto object-contain" />
          ) : (
            <span className="font-display italic text-lg md:text-2xl tracking-tight text-[color:var(--text)] group-hover:text-[color:var(--accent)] transition-colors">
              {settings.brand_name || "Weddings by Mostash"}
            </span>
          )}
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `eyebrow link-underline text-[0.7rem] ${isActive ? "text-[color:var(--accent)]" : "text-[color:var(--text)]"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <button
          data-testid="mobile-nav-toggle"
          aria-label="Menu"
          className="md:hidden text-[color:var(--text)]"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-nav" className="md:hidden bg-[color:var(--bg)] border-t border-[color:var(--border)] px-5 py-8">
          <div className="flex flex-col gap-6">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`mnav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `font-display italic text-3xl ${isActive ? "text-[color:var(--accent)]" : "text-[color:var(--text)]"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
